/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import {
	Component,
	OnInit,
	OnDestroy,
	Input,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { startWith, takeUntil } from 'rxjs/operators';

@Component({
	selector: 'auto-hide-label',
	templateUrl: './auto-hide-label.component.html',
	styles: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutoHideLabelComponent implements OnInit, OnDestroy {
	@Input() public text = '';

	public visible$: Subject<boolean>;
	private readonly TIMEOUT = 5000;
	private timer: ReturnType<typeof setTimeout>;
	private destroy$: Subject<void>;

	constructor(protected changeDetectorRef: ChangeDetectorRef) {}

	public ngOnInit() {
		this.destroy$ = new Subject();
		this.visible$ = new Subject();
		this.visible$.pipe(startWith(false), takeUntil(this.destroy$));
	}

	public ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
		this.destroy$ = null;
	}

	// show label and auto hide after given delay
	public show(timeout: number = this.TIMEOUT): void {
		this.visible$.next(true);

		if (this.timer) {
			clearTimeout(this.timer);
			this.timer = null;
		}

		this.timer = setTimeout(() => {
			this.visible$.next(false);
		}, timeout);
	}
}
